import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { JobCandidatesCompareComponent } from './job-candidates-compare.component';

@NgModule({
  declarations: [JobCandidatesCompareComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    PipesModule
  ],
  exports: [JobCandidatesCompareComponent],
  entryComponents: [JobCandidatesCompareComponent]
})
export class JobCandidatesCompareModule { }
